let sequence = 0;
export function createRequestId(prefix = 'request'): string {
  sequence += 1;
  return `${prefix}-${Date.now().toString(36)}-${sequence.toString(36)}`;
}
